import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/clientesdashboard",
    name: "ClientesDashboard",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/Dashboard.vue"),
	},
	{
    path: "/clientesdashboardstatus",
    name: "ClientesDashboardStatus",
    beforeEnter: routeGuard,
    component: () => import("../views/DashboardStatus.vue"),
  },
  {
    path: "/clientespedidos",
    name: "ClientesPedidos",
    beforeEnter: routeGuard,
    component: () => import("../../Pedidos/views/Pedidos.vue"),
    children: [
        {
          path: ":id",
          component: () => import("../../Pedidos/views/Pedidos.vue"),
        }
      ]
  },
];
